<nav class="d-flex justify-content-between align-items-center flex-shrink-0 fixed-top border-bottom">
    @if (isSearching) {
        <ion-buttons class="mr-1">
            <ion-button class="text-primary" (click)="isSearching = false;">
                <ion-icon slot="icon-only" name="chevron-back" />
            </ion-button>
        </ion-buttons>
    } 
    @else {
        <div class="d-flex align-items-center pl-1 pl-lg-0">
            <img src="/assets/images/nav.webp" alt="UP Station Logo" class="mr-2 cursor-pointer" width="140px" height="27px" routerLink="/" routerDirection="root">

            @for (s of navMenu; track s) {
                <a class="ml-4 pl-2 fsemibold f16 d-none d-lg-flex text-uppercase text-decoration-none text-white" type="link" routerDirection="root" [routerLink]="'/' + s.route" routerLinkActive="text-primary" [routerLinkActiveOptions]="{ exact: true }">
                    <ion-icon class="f24 mr-3" name="{{ s.icon }}" />
                    {{ s.label }}
                </a>
            }
        </div>
    }

	<div class="d-flex align-items-center" [class.w-100]="isSearching" *transloco="let t;">
        @if (navMenu.length !== 0) {
            <div class="nav-search mx-lg-3 mx-xl-4 mx-0 pt-1 d-none d-lg-flex rounded" [class.d-flex]="isSearching">
                <ups-select
                    width="100"
                    class="m-0"
                    value="Article"
                    [options]="[
                        { label: 'Article', value: 'Article' },
                        { label: 'Watch', value: 'Watch' },
                        { label: 'Deals', value: 'Deals' }
                    ]"
                    #select
                />

                <ion-icon name="search" class="f20 border-left pl-2 mr-1 flex-shrink-0" />
                <input type="search" placeholder="{{ t('form.search') }}" class="p-2 mb-1 bg-transparent w-100" #i (change)="search(i, select.value)" autocomplete="off" />
            </div>
        }

        @if (!isSearching) {
            <ion-buttons class="d-lg-none">
                <ion-button (click)="isSearching = true;" aria-label="Search button">
                    <ion-icon name="search" slot="icon-only" class="f24" />
                </ion-button>
            </ion-buttons>

            @if (!user().guid) {
                <button class="btn btn-primary fsemibold px-3 ml-3 ml-lg-0 mr-2 mr-lg-0" (click)="openLogin();">
                    {{ t('button.auth.signin') }}
                </button>
            } 
            @else {
                <div class="d-none d-lg-flex align-items-center cursor-pointer rounded p-1" id="p-btn">
                    <ups-avatar [src]="user()!.photo" />
                    <div class="fsemibold name pl-2 pr-1">{{ user()!.name }}</div>
                </div>

                <ion-buttons class="d-lg-none">
                    <ion-button (click)="logout();">
                        <ion-icon name="log-out" slot="icon-only" class="f24" />
                    </ion-button>
                </ion-buttons>

                <ion-popover trigger="p-btn" [dismissOnSelect]="true">
                    <ng-template>
                        <ion-list class="border rounded py-0">
                            <ion-item button lines="full" routerLink="/profile" routerDirection="root">
                                <ups-avatar class="mr-3 my-2" [src]="user()!.photo" />
                                <div class="my-2">
                                    <div class="fsemibold name text-truncate">{{ user()!.name }}</div>
                                    <div class="f12 c-gray">{{ t('button.see_profile') }}</div>
                                </div>

                                <ion-icon name="chevron-forward" slot="end" class="text-white f16" />
                            </ion-item>

                            <ion-item button lines="none" (click)="logout();">
                                <ion-label class="f14">{{ t('button.auth.signout') }}</ion-label>
                                <ion-icon name="log-out" slot="start" class="text-white" />
                            </ion-item>
                        </ion-list>
                    </ng-template>
                </ion-popover>
            }

            <div class="fflag-up fflag-{{ activeCountry().code }} cursor-pointer ml-lg-3 ml-xl-4 ml-2" title="{{ activeCountry().name }}" (click)="openCountryModal();"></div>

            <div class="d-none d-xl-flex align-items-center ml-3" role="group">
                @for (l of activeCountry().langCodes; track l) {
                    <button class="cursor-pointer p-2 fsemibold text-center border lang-item" type="button" [class.bg-primary]="l === activeLang()" (click)="changeLang(l);">
                        {{ l }}
                    </button>
                }
            </div>
        }
	</div>
</nav>

<ion-content class="flex-grow-1">
	<ion-router-outlet />
</ion-content>

<ups-footer mode="mobile" />
